import React from 'react';
import {DragDropContext, Droppable} from "react-beautiful-dnd";
import {del} from "object-path-immutable";
import {Icon, IconButton, makeStyles, Tooltip, Typography} from "@material-ui/core";
import findByString from "../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import ChoiceFormDialog from "./ChoiceFormDialog";
import ChoiceItem from "./ChoiceItem";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        position: 'relative',
    },
    choicesContainer: {
        width: "100%",
    },
}))
const initialDialogState = {isOpen: false, index: null, record: null};

const Choices = ({onChange, record}) => {
    const [openCreate, setOpenCreate] = React.useState(initialDialogState);
    const choices = findByString(record, `choices`) || [];
    const classes = useStyles();

    function createValues(record) {
        onChange(record, 'choices.' + (openCreate.index ? openCreate.index : (choices?.length || 0)));
    }

    function onEdit(index) {
        setOpenCreate({
            isOpen: true,
            index,
            record: choices[index]
        })
    }

    function removeItem(index) {
        const newValues = del(choices, index)
        onChange(newValues, 'choices')
    }

    function onDragEnd(result) {
        const reorder = (list, startIndex, endIndex) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return result;
        };
        const reordered = reorder(choices, result.source.index, result.destination.index);
        onChange(reordered, `choices`)
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div className={classes.container}>
                <div style={{
                    width: '100%',
                    display: "flex",
                    background: 'rgba(0,0,0,0.04)',
                    padding: 10,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',

                }}>
                    <div style={{width: '35%'}}>
                        <Typography variant={"subtitle2"}
                                    style={{fontWeight: 600}}
                        >Choice Id</Typography>
                    </div>
                    <div style={{width: '35%'}}
                    >
                        <Typography variant={"subtitle2"}
                                    style={{fontWeight: 600}}
                        >Label</Typography>
                    </div>
                    <div style={{width: '35%'}}>
                        <Typography variant={"subtitle2"}
                                    style={{fontWeight: 600}}
                        >Points</Typography>
                    </div>
                    <div style={{
                        padding: "10px 22px",
                        visibility: 'hidden'
                    }}>
                        a
                    </div>
                </div>
                <Droppable droppableId={'choices'}>
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className={classes.choicesContainer}
                        >
                            {choices.map((choice, index) => {
                                return (
                                    <ChoiceItem
                                        key={index}
                                        choice={choice}
                                        index={index}
                                        removeGroup={removeItem}
                                        onEdit={onEdit}
                                    />
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                <>
                    {!choices.length &&
                        <Typography variant={"subtitle2"} color={"textSecondary"}
                                    style={{padding: "15px 0 5px 0"}}
                        >No choices found</Typography>}
                    <Tooltip title={'Create new'}>
                        <IconButton size="small" onClick={() => {
                            setOpenCreate({isOpen: true})
                        }}
                                    style={{marginTop: 10}}>
                            <Icon fontSize={"small"}>
                                add
                            </Icon>
                        </IconButton>
                    </Tooltip>
                </>
                <ChoiceFormDialog
                    dialogState={openCreate}
                    onClose={() => setOpenCreate(initialDialogState)}
                    saveValues={createValues}
                />
            </div>
        </DragDropContext>
    )
}
export default Choices;
